import Carrousel from "../ProjectCarrousel/Carrousel";

const MyProjects = () =>{
    return (
        <div className={"w-full text-left"}>
            <Carrousel/>
        </div>
    )
}

export default MyProjects
